import React, { Component } from "react";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";

import { TooltipIcon } from "./TooltipIcon";
import { isMobile } from "utils/style";

class Tooltip extends Component {
  state = {
    buttonId: uuidv4(),
    contentId: uuidv4(),
    showTooltip: false,
    offsetAmount: null,
    offScreenAmount: null
  };

  showTooltip = () => {
    this.setState({ showTooltip: true });
  };

  hideTooltip = () => {
    this.setState({ showTooltip: false });
  };

  tooltipClick = e => {
    e.preventDefault();
    this.setState({ showTooltip: !this.state.showTooltip });
  };

  tooltipEscape = e => {
    if (e.keyCode === 27) {
      this.setState({ showTooltip: false });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.showTooltip !== prevState.showTooltip) {
      if (this.state.showTooltip) {
        const el = document.getElementById(this.state.contentId);

        if (el.getBoundingClientRect().left < 0) {
          const currentStyle = parseFloat(window.getComputedStyle(el).left);
          const offScreenAmount = el.getBoundingClientRect().left;
          const offsetAmount = currentStyle - offScreenAmount;

          this.setState({ offsetAmount, offScreenAmount });
        }
      }
    }
  }

  render() {
    return (
      <Div {...this.props}>
        <Button
          id={this.state.buttonId}
          aria-label="more information tooltip"
          aria-describedby={this.state.contentId}
          aria-expanded={this.state.showTooltip}
          onClick={this.tooltipClick}
          onMouseOver={!isMobile ? this.showTooltip : undefined}
          onMouseOut={this.hideTooltip}
          onFocus={!isMobile ? this.showTooltip : undefined}
          onBlur={this.hideTooltip}
          onKeyDown={this.tooltipEscape}
        >
          <TooltipIcon />
        </Button>
        {this.state.showTooltip ? (
          <Content
            id={this.state.contentId}
            offScreenAmount={this.state.offScreenAmount}
            offsetAmount={this.state.offsetAmount}
            aria-hidden={!this.state.showTooltip}
            role="tooltip"
          >
            {this.props.children}
          </Content>
        ) : null}
      </Div>
    );
  }
}

export default Tooltip;

const Div = styled.div`
  position: relative;
`;

const Button = styled.button`
  padding: 0;
  border: 0;
  background: 0;
  font-size: 0;
  line-height: 0;
  cursor: pointer;
`;

const Content = styled.span`
  display: block;
  position: absolute;
  bottom: 24px;
  left: ${({ offsetAmount }) => (offsetAmount ? `${offsetAmount}px` : "-104px")};
  width: 200px;
  background: #fff;
  border: 1px solid;
  padding: 12px;
  font-size: 12px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  line-height: 14px;

  p {
    margin-bottom: 4px;
    font-size: 12px;
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    line-height: 14px;
  }

  ::before {
    content: "";
    position: absolute;
    box-sizing: border-box;
    border-right: 0.0625rem solid #000000;
    border-bottom: 0.0625rem solid #000000;
    width: 0.53125rem;
    height: 0.53125rem;
    bottom: -5px;
    background: white;
    left: ${({ offScreenAmount }) =>
    offScreenAmount ? `calc(50% - ${Math.abs(offScreenAmount)}px)` : "calc(50% - 0px)"};
    transform: translate(-50%) rotate(45deg);
    will-change: transform, left;
    z-index: 0;
  }
`;
